import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute bottom-0 left-0 right-0 bg-black opacity-80 h-[40px] rounded-b-xl flex justify-center space-x-3 items-center cursor-pointer" }
const _hoisted_2 = ["id"]

import { onMounted, ref } from "vue";
	import { makeFakeID } from "@/utils";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewTag',
  props: {
		icon: {
			type: String,
			default: "/media/icons/arrow-down-icon.svg",
		},
		css: {
			type: String,
			default: "w-full h-3/5",
		},
	},
  emits: ["model"],
  setup(__props, { emit: __emit }) {

	const inputFile = ref(makeFakeID(5));
	const inputTagID = ref<any>(makeFakeID(5));
	const inputTag = ref<any>(null);
	const previewImage = ref<any>(null);

	const props = __props;

	const emit = __emit;

	const getDataFiled = (event: any) => {
		// Create a new 'change' event
		if (event.target.files && event.target.files[0]) {
			let reader = new FileReader();
			reader.onload = (e) => {
				previewImage.value = e.target?.result;
			};
			reader.readAsDataURL(event.target.files[0]);

			emit("model", {
        file: event.target.files[0]
      });
		}
	};

	onMounted(() => {
		inputTag.value = document.getElementById(inputTagID.value);
	});

return (_ctx: any,_cache: any) => {
  const _component_ImageView = _resolveComponent("ImageView")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative flex", __props.css])
  }, [
    _createVNode(_component_ImageView, {
      src: previewImage.value != null ? previewImage.value : '/media/images/thumbnail-3-img.svg',
      css: "h-full rounded-xl w-full"
    }, null, 8, ["src"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Icon, {
        src: '/media/icons/image-illustration-icon.svg',
        css: 'w-6 h-6'
      }),
      _createElementVNode("p", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$refs[inputFile.value].click()))
      }, "Changer l'illustration"),
      _createElementVNode("input", {
        id: inputTagID.value,
        type: "file",
        ref: inputFile.value,
        class: "hidden",
        onChange: getDataFiled
      }, null, 40, _hoisted_2)
    ])
  ], 2))
}
}

})